import React from "react";
import bg_video from "../../dist/img/Flowdia_Q_BG_movie.mov";
// import img1 from "../../dist/img/question7_img/q7_01.jpg";
// import img1_sp from "../../dist/img/question7_img/q7_01_sp.jpg";
// import img2 from "../../dist/img/question7_img/q7_02.jpg";
// import img2_sp from "../../dist/img/question7_img/q7_02_sp.jpg";
// import img3 from "../../dist/img/question7_img/q7_03.jpg";
// import img3_sp from "../../dist/img/question7_img/q7_03_sp.jpg";
// import img4 from "../../dist/img/question7_img/q7_04.jpg";
// import img4_sp from "../../dist/img/question7_img/q7_04_sp.jpg";
import { useLocation, Link } from "react-router-dom";
import lv4 from "../../dist/img/question7_img/lv4.png";
import lv5 from "../../dist/img/question7_img/lv5.png";
import lv6 from "../../dist/img/question7_img/lv6.png";
import lv7 from "../../dist/img/question7_img/lv7.png";
import lv8 from "../../dist/img/question7_img/lv8.png";
import lv9 from "../../dist/img/question7_img/lv9.png";
import lv10 from "../../dist/img/question7_img/lv10.png";
import lv11 from "../../dist/img/question7_img/lv11.png";
import lv12 from "../../dist/img/question7_img/lv12.png";

const Question7 = ({deleteStep , addStep, pointsHandler }) => {
  const answerHandler = (option) => {
    addStep();
    pointsHandler(option);
  };
  return (
    <section className="c-question">
      <video poster="" autoPlay loop playsInline muted>
        <source src={bg_video} type="video/mp4"></source>
      </video>
  
      <section className="c-question__progress">
        <dl>
          <dt>QUESTION</dt>
          <dd>
            8 / <span>14</span>
          </dd>
        </dl>
      </section>

      <section className="c-question__content p-question__content p-question__content--7 c-box2">
        <h1 className="c-question__title">髪の明るさは？</h1>
        <section
          onClick={() => {
            answerHandler(0);
          }}
          className="c-question__option p-question__option p-question__option--7"
        >
          <div>
            <h3>4Lv</h3>
            <p>
              ヘアカラーはしていない、
              <br className="u-sp" />
              黒髪や白髪
            </p>
          </div>
          <div>
            <div>
              <p>4</p>
              <img src={lv4} alt="" />
            </div>
          </div>
        </section>
        <section
          onClick={() => {
            answerHandler(1);
          }}
          className="c-question__option p-question__option p-question__option--7"
        >
          <div>
            <h3>5Lv 〜 6Lv</h3>
            <p>
              暗めのヘアカラーや
              <br className="u-sp" />
              白髪染めをしている
            </p>
          </div>
          <div>
            <div>
              <p>5</p>
              <img src={lv5} alt="" />
            </div>
            <div>
              <p>6</p>
              <img src={lv6} alt="" />
            </div>
          </div>
        </section>
        <section
          onClick={() => {
            answerHandler(2);
          }}
          className="c-question__option p-question__option p-question__option--7"
        >
          <div>
            <h3>7Lv 〜 10Lv</h3>
            <p>
              やや明るいヘアカラーや
              <br />
              白髪染めをしている
            </p>
          </div>
          <div>
            <div>
              <p>7</p>
              <img src={lv7} alt="" />
            </div>
            <div>
              <p>8</p>
              <img src={lv8} alt="" />
            </div>
            <div>
              <p>9</p>
              <img src={lv9} alt="" />
            </div>
            <div>
              <p>10</p>
              <img src={lv10} alt="" />
            </div>
          </div>
        </section>
        <section
          onClick={() => {
            answerHandler(3);
          }}
          className="c-question__option p-question__option p-question__option--7"
        >
          <div>
            <h3>11Lv以上</h3>
            <p>明るいヘアカラーをしている</p>
          </div>
          <div>
            <div>
              <p>11</p>
              <img src={lv11} alt="" />
            </div>
            <div>
              <p>12</p>
              <img src={lv12} alt="" />
            </div>
          </div>
        </section>
        <Link style ={{  margin: "25px auto"}} onClick={() => deleteStep()}  className="c-question__btn2 p-output__btn--v2">
          BACK
        </Link>
      </section>
    </section>
  );
};

export default Question7;
